import {Component, OnInit} from '@angular/core';
import {ViewportScroller} from '@angular/common';
import {Router} from '@angular/router';
import {StoreService} from "../../../lib/core/common/store/store.service";

@Component({
  selector: 'app-charts-service',
  templateUrl: './charts-service.component.html',
  styleUrls: ['./charts-service.component.scss']
})
export class ChartsServicesComponent implements OnInit {

  constructor(private viewportScroller: ViewportScroller,
              private store: StoreService,
              private router: Router) {}

  goToInstagramChart() {
    this.store.setObject('social-type-chart', 'instagram');
      this.router.navigate(['/classifiche']).then();
  }

  goToTikTokChart() {
    this.store.setObject('social-type-chart', 'tiktok');
      this.router.navigate(['/classifiche']).then();
  }

  ngOnInit() {
  }

}
